import { useJackpotStore } from '@stores/jackpotStore'
import {
    JackpotLinkTypes,
    JackpotLinkStatistics,
    JackpotShowStonePickedMessage,
    GameUIMessageType,
} from 'game-ui-types'

let iteration = 1

const getRandomInt = (max = 99999999) => {
    return Math.floor(Math.random() * max)
}

const balances = [getRandomInt(), getRandomInt()]
const winAmounts = [...balances]
let isJackpotLinkHoldSpin = false
const pickedStones = {
    [JackpotLinkTypes.GRAND]: 0,
    [JackpotLinkTypes.MAJOR]: 0,
}

const demoPickedStones = (numberOfGrand = 1) => {
    setTimeout(() => {
        const jackpotShowStonePickedMessage: JackpotShowStonePickedMessage = {
            type: GameUIMessageType.JACKPOT_SHOW_STONE_PICKED,
            coinType: numberOfGrand > 3 ? JackpotLinkTypes.MAJOR : JackpotLinkTypes.GRAND,
            tweensDuration: 0.6,
        }

        window.postMessage(jackpotShowStonePickedMessage)

        if (numberOfGrand < 4) {
            demoPickedStones(numberOfGrand + 1)
        }
    }, 1000)
}

export const useJackpotLinkMock = () => {
    if (iteration === 1) {
        console.warn('[Game-UI]: Using Mock Jackpot Link Statistics')
    } else if (iteration % 3 === 0) {
        isJackpotLinkHoldSpin = true
        demoPickedStones()
    } else {
        isJackpotLinkHoldSpin = false
        pickedStones[JackpotLinkTypes.GRAND] = 0
        pickedStones[JackpotLinkTypes.MAJOR] = 0
    }

    const newBalances = [getRandomInt(), getRandomInt()]

    newBalances.forEach((n, i) => {
        if (n < balances[i]) {
            winAmounts[i] = balances[i]
        }

        balances[i] = n
    })

    const mockData: JackpotLinkStatistics = {
        currency: 'EUR',
        levels: [
            {
                // Major
                balance: balances[0],
                winCount: 6,
                largestWin: {
                    gin: 8001,
                    winAmount: 180000,
                    winDate: '2025-02-04T14:52:28.022Z',
                    winUser: 'Justin',
                },
                lastWin: {
                    gin: 8006,
                    winAmount: winAmounts[0],
                    winDate: '2025-02-20T12:12:49.665Z',
                    winUser: `Major${winAmounts[0]}`,
                },
                lastWinners: [
                    {
                        gin: 8006,
                        winAmount: 162000,
                        winDate: '2025-02-20T12:12:49.665Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8004,
                        winAmount: 171000,
                        winDate: '2025-02-20T12:11:30.928Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 903,
                        winAmount: 161000,
                        winDate: '2025-02-20T11:48:59.687Z',
                        winUser: 'JustinJustin',
                    },
                    {
                        gin: 903,
                        winAmount: 161000,
                        winDate: '2025-02-20T11:48:32.656Z',
                        winUser: 'JustinJustin',
                    },
                    {
                        gin: 8001,
                        winAmount: 163000,
                        winDate: '2025-02-04T14:52:37.338Z',
                        winUser: 'Justin',
                    },
                ],
                topMonthlyWinners: [
                    {
                        gin: 8001,
                        winAmount: 180000,
                        winDate: '2025-02-04T14:52:28.022Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8004,
                        winAmount: 171000,
                        winDate: '2025-02-20T12:11:30.928Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8001,
                        winAmount: 163000,
                        winDate: '2025-02-04T14:52:37.338Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8006,
                        winAmount: 162000,
                        winDate: '2025-02-20T12:12:49.665Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 903,
                        winAmount: 161000,
                        winDate: '2025-02-20T11:48:59.687Z',
                        winUser: 'JustinJustin',
                    },
                ],
                topYearlyWinners: [
                    {
                        gin: 8001,
                        winAmount: 180000,
                        winDate: '2025-02-04T14:52:28.022Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8004,
                        winAmount: 171000,
                        winDate: '2025-02-20T12:11:30.928Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8001,
                        winAmount: 163000,
                        winDate: '2025-02-04T14:52:37.338Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8006,
                        winAmount: 162000,
                        winDate: '2025-02-20T12:12:49.665Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 903,
                        winAmount: 161000,
                        winDate: '2025-02-20T11:48:59.687Z',
                        winUser: 'JustinJustin',
                    },
                ],
            },
            {
                // Grand
                balance: balances[1],
                winCount: 18,
                largestWin: {
                    gin: 8004,
                    winAmount: 1051000,
                    winDate: '2025-02-20T12:11:13.562Z',
                    winUser: 'Justin',
                },
                lastWin: {
                    gin: 8002,
                    winAmount: winAmounts[1],
                    winDate: '2025-02-20T15:24:16.724Z',
                    winUser: `Grand${winAmounts[1]}`,
                },
                lastWinners: [
                    {
                        gin: 8002,
                        winAmount: 1011000,
                        winDate: '2025-02-20T15:24:16.724Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8008,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:21.159Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8006,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:16.744Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8005,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:13.429Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8004,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:09.168Z',
                        winUser: 'Justin',
                    },
                ],
                topMonthlyWinners: [
                    {
                        gin: 8004,
                        winAmount: 1051000,
                        winDate: '2025-02-20T12:11:13.562Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8002,
                        winAmount: 1035000,
                        winDate: '2025-02-20T12:14:36.688Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8008,
                        winAmount: 1013000,
                        winDate: '2025-02-20T12:14:56.351Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8002,
                        winAmount: 1011000,
                        winDate: '2025-02-20T15:24:16.724Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8008,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:21.159Z',
                        winUser: 'Justin',
                    },
                ],
                topYearlyWinners: [
                    {
                        gin: 8004,
                        winAmount: 1051000,
                        winDate: '2025-02-20T12:11:13.562Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8002,
                        winAmount: 1035000,
                        winDate: '2025-02-20T12:14:36.688Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8008,
                        winAmount: 1013000,
                        winDate: '2025-02-20T12:14:56.351Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8002,
                        winAmount: 1011000,
                        winDate: '2025-02-20T15:24:16.724Z',
                        winUser: 'Justin',
                    },
                    {
                        gin: 8008,
                        winAmount: 1011000,
                        winDate: '2025-02-20T14:17:21.159Z',
                        winUser: 'Justin',
                    },
                ],
            },
        ],
        schemaSettings: {
            betSectors: [
                {
                    betRanges: [50, 100, 150, 200, 250],
                    mini: 1000,
                    minor: 5000,
                },
                {
                    betRanges: [300, 500, 750, 1000, 1500],
                    mini: 6000,
                    minor: 30000,
                },
                {
                    betRanges: [2000, 2500, 3000, 4000, 5000],
                    mini: 20000,
                    minor: 100000,
                },
            ],
            coefficient: '1.0000000000',
        },
    }

    useJackpotStore.setState({ isJackpotLinkHoldSpin, pickedStones, jackpotLinkStatistics: mockData })

    setTimeout(() => {
        iteration = iteration + 1
        useJackpotLinkMock()
    }, 5000)
}
